<template>
  <v-chip :color="active ? 'success' : 'warning'"
          v-bind="$attrs">
    {{ status }}
  </v-chip>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    }
  },
  computed: {
    active() {
      return this.status === 'Active';
    }
  }
}
</script>
